import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const MiniTaskContent = ({ task, completionMessage, onComplete }) => {
  const [isCompleted, setIsCompleted] = useState(false);

  const handleComplete = () => {
    setIsCompleted(true);
    if (onComplete) {
      onComplete();
    }
  };

  return (
    <div className="space-y-6 md:space-y-8">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 rounded-xl flex items-center justify-center flex-shrink-0 bg-success/10">
          <Icon name="CheckSquare" size={24} color="var(--color-success)" />
        </div>
        <div className="flex-1">
          <h3 className="text-xl md:text-2xl lg:text-3xl font-heading font-semibold text-foreground mb-3 md:mb-4">
            Bugünün Görevi
          </h3>
          <p className="text-base md:text-lg lg:text-xl text-foreground leading-relaxed">
            {task || 'Bugün yolculuğunda emniyet kemerini tak ve tüm yolcuların da takmasını sağla. Güvenlik herkese lazım!'}
          </p>
        </div>
      </div>

      {isCompleted && completionMessage && (
        <div className="p-4 md:p-5 rounded-lg bg-success/10 border border-success/20">
          <p className="text-sm md:text-base text-foreground flex items-center gap-2">
            <Icon name="CheckCircle" size={18} color="var(--color-success)" />
            {completionMessage}
          </p>
        </div>
      )}

      <Button
        variant={isCompleted ? 'success' : 'default'}
        size="lg"
        fullWidth
        onClick={handleComplete}
        disabled={isCompleted}
        iconName={isCompleted ? 'CheckCircle' : 'Check'}
        iconPosition="left"
      >
        {isCompleted ? 'Tamamlandı' : 'Yaptım'}
      </Button>
    </div>
  );
};

export default MiniTaskContent;